import React, { Component, PropTypes } from "react";
import LeftComponent from "components/Authorization/LeftComponent";
import LoginForm from "components/Authorization/Login/LoginForm";
import { connect } from "react-redux";
import actions from "actions";
import { sendConfirmationCode } from "../../../actions/auth";
const { login } = actions;

class LoginAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "", passwordType: "password" };
  }

  onFieldChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onPasswordTypeChange = (status) => {
    this.setState({
      passwordType: status ? "text" : "password",
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { passwordType, email, password } = this.state;
    this.props.sendConfirmationCode({ email: email.toLowerCase(), password });
  };

  render() {
    const { email, password } = this.state;

    return (
      <main className="">
        <div className="container_content_signin">
          <LeftComponent />
          <LoginForm
            email={email}
            password={password}
            passwordType={this.state.passwordType}
            onFieldChange={this.onFieldChange}
            onSubmit={this.onSubmit}
            onPasswordTypeToggle={this.onPasswordTypeChange}
            redirectBack={this.props.location.query.redirectBack}
            title="Admin Log In"
            isAdmin={true}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
  return {
    sendConfirmationCode: (payload) => {
      dispatch(sendConfirmationCode(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginAdmin);



// WEBPACK FOOTER //
// ./src/containers/Authorization/LoginAdmin/index.jsx